import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AppInitializerService } from '@services/appInitializer.service';
import { AuthenticationService } from '@services/AuthService/auth.service';
import { UserLocalService } from '@services/UserService/user-local.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private userService: UserLocalService,
        private authService: AuthenticationService,
        private appInitializerService: AppInitializerService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isLoggedIn = this.authService.isLoggedIn;
        const tryingToAccessLogin = state.url === '/login';

        // 1. Redirect logged-in users away from Login page
        if (isLoggedIn && tryingToAccessLogin) {
            return this.router.navigate(['/dashboard']);
        }

        // 2. Redirect guests to Login page
        if (!isLoggedIn && !tryingToAccessLogin) {
            return this.router.navigate(['/login']);
        }

        // 3. Ensure user data is loaded (very important for manual URL typing)
        await this.appInitializerService.init();

        // 4. ROLE CHECK — hierarchical: SuperAdmin(0) > Admin(1) > User(2)
        // minRole defines the minimum privilege level required.
        // A user passes if their role code is <= minRole (lower = higher privilege).
        const minRole: number | undefined = route.data['minRole'];
        const userRole: number = this.userService.userRoleCode;

        if (minRole !== undefined && userRole > minRole) {
            console.warn('Access Denied. User role:', userRole, 'Required minRole:', minRole);
            await this.router.navigate(['/dashboard']);
            return false;
        }

        return true;
    }
}
